export default "__VITE_ASSET__Ds1urg1o__"